module.exports = __webpack_public_path__ + "static/media/personal-information-4.d195d70a.svg";